import { Icon } from "@/components"
import { useStyles } from "@/components/Controlled/ErrorMessages.styles"
import { useMantineTheme } from "@mantine/core"
import React from "react"
import { FieldError } from "react-hook-form"

interface ErrorMessagesProps {
    fieldError: FieldError
}

export const ErrorMessages = ({ fieldError, ...props }: ErrorMessagesProps) => {
    const { classes } = useStyles()
    const theme = useMantineTheme()
    const errors = fieldError.types
        ? Object.entries(fieldError.types).reduce((acc, [_validator, errorMessage]) => {
              acc.push(errorMessage)
              return acc
          }, [])
        : [fieldError.message]

    return (
        <div className={classes.container}>
            {errors.map((error) => (
                <span key={error} className={classes.error} {...props}>
                    <Icon icon="exclamation-triangle" size="xs" /> {error}
                </span>
            ))}
        </div>
    )
}
